import { useRef } from 'react';

import {
  ChevronRightIcon,
  Cross1Icon,
  DownloadIcon
} from '@radix-ui/react-icons';
import { Flex, IconButton, Skeleton, Text } from '@raystack/apsara';
import { Show } from '@studio/hoc';

import { useGetBlockDetails } from '@src/hooks/useBlocksHooks';
import {
  BREADCRUMBS_STAGE_A,
  BREADCRUMBS_STAGE_A_INACTIVE,
  INFERENCE_STAGES
} from '@src/utils/constants/MODE_INFERENCE_DEFAULTS';

import { DownloadInsightsPopup } from '../DownloadInsights';

import styles from './styles.module.css';

export const InsightHeader = ({
  stage,
  onClose,
  onBackButtonClick,
  onModelBackClick,
  activeInsight,
  activeModel
}) => {
  const inputTitle = activeModel?.title ?? null;

  const { name } = activeInsight;

  const title = name;

  return (
    <div className={styles.header}>
      <Flex gap='small' align='center'>
        {BREADCRUMBS_STAGE_A.includes(stage) && (
          <Text
            size='4'
            weight={500}
            variant={
              BREADCRUMBS_STAGE_A_INACTIVE.includes(stage)
                ? 'tertiary'
                : 'primary'
            }
            data-test-id='back-to-inference-list-btn'
            onClick={onBackButtonClick}
          >
            Insights
          </Text>
        )}

        {stage === INFERENCE_STAGES.modeList && (
          <>
            <ChevronRightIcon />
            <Text size='4' weight={500} variant='primary'>
              New Insight
            </Text>
          </>
        )}

        {stage === INFERENCE_STAGES.inferenceInput && (
          <>
            <Text
              size='4'
              weight={500}
              variant='tertiary'
              onClick={onModelBackClick}
              data-test-id='back-to-model-list-btn'
            >
              New Insight
            </Text>

            {inputTitle && <ChevronRightIcon />}

            <Text size='4' weight={500} className={styles.InsightTitle}>
              {inputTitle}
            </Text>
          </>
        )}

        {stage === INFERENCE_STAGES.inferenceOutput &&
          title !== 'undefined' && (
            <>
              <ChevronRightIcon />
              <Text size='4' weight={500} variant='primary'>
                {title}
              </Text>
            </>
          )}
      </Flex>

      <IconButton
        size={3}
        onClick={onClose}
        data-test-id='close-insights-panel-btn'
      >
        <Cross1Icon />
      </IconButton>
    </div>
  );
};

export const InsightsOutputHeader = ({
  activeInsight,
  titleTailingContent = null
}) => {
  const { name = '', version = '' } = activeInsight?.block_info || {};

  const { data, isLoading } = useGetBlockDetails({
    blockName: name,
    blockVersion: version
  });

  const popupRef = useRef(null);

  return (
    <Flex align='stretch' justify='between' style={{ width: '100%' }}>
      <Flex gap='small'>
        <Show when={!isLoading} fallback={<Skeleton count={1} width={200} />}>
          <Text size={2} weight={500} variant='primary'>
            {data?.spec?.title || ''}
          </Text>
        </Show>
        {titleTailingContent}
      </Flex>

      <IconButton
        size={3}
        data-test-id='download-insight-btn'
        onClick={() => {
          popupRef.current?.setShowDialog();
        }}
      >
        <DownloadIcon />
      </IconButton>
      <DownloadInsightsPopup activeInsight={activeInsight} ref={popupRef} />
    </Flex>
  );
};
